//import { v4 as uuidv4 } from 'uuid';

export const annotation = {
  state: {
    annotations: {
      /*
        uuid: {
          uuid:
          num:
          left:
          top:
          width:
          height:
          angle:
          image_uuid:
          remarks: ""
        }
      */
    },
    image_annotations: {
      /*
        uuid: [ // uuid of image
          "uuid" // uuid of annotation
        ]
      */
    }
  },

  mutations: {
    updateAnnotation(state, newAnnotation) {
      state.annotations[newAnnotation.uuid] = newAnnotation;
      if (state.image_annotations[newAnnotation.image_uuid]) {
        if (!state.image_annotations[newAnnotation.image_uuid].includes(newAnnotation.uuid)) {
          state.image_annotations[newAnnotation.image_uuid].push(newAnnotation.uuid);
        }
      } else {
        state.image_annotations[newAnnotation.image_uuid] = [newAnnotation.uuid];
      }
    },

    removeAnnotation(state, annotationUUID) {
      const annotation = state.annotations[annotationUUID];
      if (annotation) {
        const image_uuid = annotation.image_uuid;
        //delete state.annotations[annotationUUID];

        state.annotations = state.annotations.filter(function(aUUID) {
          return aUUID !== annotationUUID;
        });

        state.image_annotations[image_uuid] = state.image_annotations[image_uuid].filter(function(aUUID) {
          return aUUID !== annotationUUID;
        });
      }
    },

    removeImageAnnotations(state, image_uuid) {
      const annotationUUIDs = state.image_annotations[image_uuid];
      console.log("Inside annotation.module.js, annotationUUIDs ==> ", annotationUUIDs);
      if (annotationUUIDs) {
        annotationUUIDs.forEach(function(annotationUUID) {
          delete state.annotations[annotationUUID];        
        });
        delete state.image_annotations[image_uuid];
      }
    },

    removeAllAnnotations(state) {
      state.annotations = {};
      state.image_annotations = {};
    }
  },

  actions: {
    submitAnnotation({ commit, getters }, updating_annotation) {
      const existing_annotation = getters.annotationByUUID(updating_annotation.uuid);

      // if there is an existing annotation, merge the updating annotation with the exisitng one
      if (existing_annotation) {
        updating_annotation = {
          ...existing_annotation,
          ...updating_annotation
        }
      }

      // assign an annotation number if there isn't one
      if (!updating_annotation.num) {
        updating_annotation.num = getters.lastAnnotationNum(updating_annotation.image_uuid) + 1
      }

      console.log("Inside annotation.module.js, updating_annotation ==> ", updating_annotation);

      commit('updateAnnotation', updating_annotation);
    },

    deleteAnnotation({ commit }, annotation_uuid) {
      commit('removeAnnotation', annotation_uuid);
    },

    clearImageAnnotations({ commit }, image_uuid) {
      commit('removeImageAnnotations', image_uuid);
    },

    clearAllAnnotations({ commit }) {
      commit('removeAllAnnotations');
    }
  },

  getters: {
    allAnnotations(state) {
      return state.annotations
    },

    annotationByUUID(state) {
      return function(uuid) {
        return state.annotations[uuid];
      }
    },

    annotationsByImageUUID(state) {
      return function(uuid) {
        console.log("Inside annotation.module.js, state.image_annotations ==> ", state.image_annotations);
        const annotationUUIDs = state.image_annotations[uuid];
        console.log("Inside annotation.module.js, annotationUUIDs ==> ", annotationUUIDs);
        if (annotationUUIDs) {
          return annotationUUIDs.map(function(aUUID) {
            return state.annotations[aUUID];
          })
        } else {
          return []
        }
      }
    },

    lastAnnotationNum(state, getters) {
      return function(image_uuid) {
        const annotations = getters.annotationsByImageUUID(image_uuid);
        return annotations.reduce(function(last_num, annotation) {
          if (annotation.num) {
            return (annotation.num > last_num) ? annotation.num : last_num;
          } else {
            return last_num
          }
        }, 0);
      }
    }

  }


}
